export const PropTypes = require('prop-types'); // https://github.com/facebook/prop-types#readme
export const QueryString = require('query-string'); // https://github.com/sindresorhus/query-string#readme
export const Lodash = require('lodash'); // https://lodash.com/
export const { Editor } = require('react-draft-wysiwyg'); // https://jpuri.github.io/react-draft-wysiwyg
